import { AnalyticIdentifier } from '@common/neo.tax';
import { ReactElement } from 'react';

import { AuthType, LocalStorageKey, redirectToIntuitOAuth, useAnalyticId } from '@neo.tax/shared';

import { StyledIntuitIcon, StyledSsoButton } from './sso-buttons.styled';

export const IntuitOAuth = ({ authType }: { authType: AuthType }): ReactElement => {
  const intuitOAuthBtnId = useAnalyticId(AnalyticIdentifier.RTC_INTUIT_OAUTH_BUTTON);

  const handleClick = (): void => {
    localStorage.setItem(LocalStorageKey.SESSION_INTUIT_AUTH_ATTEMPT, authType);
    redirectToIntuitOAuth();
  };

  return (
    <StyledSsoButton id={intuitOAuthBtnId} onClick={handleClick} rounded="regular" size="base" variant="white">
      <StyledIntuitIcon /> Intuit
    </StyledSsoButton>
  );
};
